import React, { useContext, useEffect, useState } from "react";
import PsContext from "../../context";
import Header from "../header";
import { Dialog, Toast } from "antd-mobile";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  localSettingsValues,
  MOB_ICONS,
  momentDate,
  PsLabel,
  PsSelect,
  upperCase,
} from "../../utils";
import { TABLE_STYLES } from "../../utils/data";
import ReactFileReader from "react-file-reader";
import { Image } from "antd";

const StudentTransfer = () => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [applyTransfer, setApplyTransfer] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [feePending, setFeePending] = useState([]);
  const [allColleges, setAllColleges] = useState([]);
  const [selectedCollege, setSelectedCollege] = useState("");
  const [colleges, setColleges] = useState([]);
  const [challanNo, setChallanNo] = useState("");
  const [challanDate, setChallanDate] = useState("");
  const [redoData, setRedoData] = useState([]);
  const [exists, setExists] = useState([]);
  const [authoritySignFile, setAuthoritySignFile] = useState(null);
  const [ranklistFile, setRanklistFile] = useState(null);
  const [studentSignFile, setStudentSignFile] = useState(null);
  const [studentSignFileType, setStudentSignFileType] = useState("");
  const [ranklistFileType, setRanklistFileType] = useState("");

  useEffect(() => {
    loadData();
    ListColleges();
    setAuthoritySignFile(
      localSettingsValues("principal_sign", "", context.user.college_uuid),
    );
  }, []);

  const getSemType = () => {
    return context.user?.semester % 2 == 0 ? "0" : "1";
  };

  const ListColleges = () => {
    setLoader(true);
    axios.post(ServiceUrl.STUDENTS.LIST_COLLEGES).then((res) => {
      if (res["data"].status == "1") {
        setAllColleges(res["data"].data);
        let c = res["data"]?.data.filter(
          (col) => col.college_uuid != context.user.college_uuid,
        );
        setColleges(c);
      }
      setLoader(false);
    });
  };

  const loadData = () => {
    setLoader(true);

    const form = new FormData();
    form.append("college_uuid", context.user.college_uuid);
    form.append("student_uuid", context.user.student_uuid);
    form.append("course_uuid", context.user.course_uuid);
    form.append("semester", context.user.current_semester);
    form.append("batch", context.user.batch);
    form.append("college_year", context.user.college_year);
    form.append("sem_type", getSemType());
    axios
      .post(ServiceUrl.STUDENT_TRANSFER.APPLY_TRANSFER_DATE, form)
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"]?.data);
          setFeePending(res["data"]?.fee_pending);
          setChallanNo(res["data"].bill[0]?.bill_no);
          setChallanDate(res["data"].bill[0]?.bill_date);
          setRedoData(res["data"].redoData);
          setExists(res["data"].exist);
          setApplyTransfer(true);
        } else {
          //   Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  };

  const getCollegeFullName = (college_uuid, short_name = false) => {
    let foundCollege =
      allColleges &&
      allColleges.find((item) => item.college_uuid == college_uuid);
    if (short_name) {
      return upperCase(foundCollege?.college_short_name || "-");
    } else {
      return upperCase(foundCollege?.college_name || "-");
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (!selectedCollege) {
      Toast.show({ content: "Select College" });
      return;
    }

    if (!studentSignFile) {
      Toast.show({ content: "upload student sign" });
      return;
    }
    if (!authoritySignFile) {
      Toast.show({ content: "upload principal sign on master settings" });
      return;
    }
    if (!ranklistFile) {
      Toast.show({ content: "upload ranklist proof" });
      return;
    }

    // if (!challanDate) {
    //   Toast.show({ content: "Missing Bill Date" });
    //   return;
    // }
    // if (!challanNo) {
    //   Toast.show({ content: "Missing Bill Number" });
    //   return;
    // }

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    const formData = new FormData(form);

    Dialog.confirm({
      // content: "Are you sure you want to Apply for the Transfer?",
      content: (
        <ul>
          <li>
            <span className="fw-bold">a.</span> I am fully responsible for the
            details mentioned by me.
          </li>
          <li>
            <span className="fw-bold">b.</span> The details provided by me are
            true.
          </li>
          <li>
            <span className="fw-bold">c.</span> I understand the transfer
            process.
          </li>
          <li>
            <span className="fw-bold">d.</span> If I get a transfer to the
            selected college, it cannot be cancelled. I understand this.
          </li>
          <li>
            <span className="fw-bold">e.</span> College transfer is allowed only
            once in an academic year, and I understand this.
          </li>
          <li>
            <span className="fw-bold">f.</span> I agree to follow the decision
            of the Directorate of Legal Studies regarding my transfer.
          </li>
        </ul>
      ),
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: async () => {
        axios
          .post(ServiceUrl.STUDENT_TRANSFER.SAVE_TRANSFER_FORM, formData)
          .then((res) => {
            if (res["data"].status == "1") {
              form.reset();
              loadData();
              Toast.show({ content: res["data"].message || "Success" });
            } else {
              Toast.show({ content: res["data"].message || "Error" });
            }
            setLoader(false);
          });
      },
    });
  };

  const fileReaderChange = (file) => {
    var types = [
      "image/png",
      "image/jpeg",
      "image/JPEG",
      "image/jpg",
      "image/PNG",
      "image/JPG",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (!types.includes(file.fileList[0].type)) {
      Toast.show({
        content:
          "Please select a document with file extension .pdf or .doc or .jpg or .png",
      });
      return;
    }

    if (file.fileList[0].size > 2000000) {
      Toast.show({ content: "File size must less than 2 MB" });
      return;
    }

    setRanklistFileType(file.fileList[0].type);
    setRanklistFile(file.base64);
  };

  const fileReaderChangeSign = (file) => {
    var types = [
      "image/png",
      "image/jpeg",
      "image/JPEG",
      "image/jpg",
      "image/PNG",
      "image/JPG",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (!types.includes(file.fileList[0].type)) {
      Toast.show({
        content:
          "Please select a document with file extension .pdf or .doc or .jpg or .png",
      });
      return;
    }

    if (file.fileList[0].size > 2000000) {
      Toast.show({
        content: "File size must less than 2 MB",
      });
      return;
    }

    setStudentSignFileType(file.fileList[0].type);
    setStudentSignFile(file.base64);
  };

  return (
    <div>
      <Header title="Online Transfer" backAction={true} />
      <div className="container-sm">
        {/* Transfer Date */}
        {!applyTransfer && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              height: "80vh",
              textAlign: "center",
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            <span className="card p-2">The Transfer window is now closed.</span>
          </div>
        )}

        {/* Fee Pending */}
        {applyTransfer && feePending.length > 0 && (
          <Row>
            <Col md={12} className="mb-2">
              <Card>
                <Card.Header className="card-header-bg text-uppercase fw-bold">
                  <Row>
                    <Col md={8} xs={8} sm={8}>
                      Fees
                    </Col>
                    <Col className="text-end" md={4} xs={4} sm={4}>
                      {feePending.length > 0 ? (
                        <img
                          src={MOB_ICONS.PENDING}
                          style={{ width: "20px" }}
                        />
                      ) : (
                        <img
                          src={MOB_ICONS.CHECKMARK_256}
                          style={{ width: "20px" }}
                        />
                      )}
                    </Col>
                  </Row>
                </Card.Header>
                <Card.Body className="tableFixHead ps-table">
                  {feePending.length > 0 ? (
                    <table width="100%">
                      <tr>
                        <th style={TABLE_STYLES.borderAll}>Category</th>
                        <th style={TABLE_STYLES.borderAll}>Amount</th>
                      </tr>

                      {feePending.map((item) => {
                        return (
                          <tr>
                            <td style={TABLE_STYLES.borderAll}>
                              {item.category_name}
                            </td>
                            <td style={TABLE_STYLES.borderAll}>
                              {parseFloat(item.fee_amount)}
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <th
                          className="text-danger"
                          style={TABLE_STYLES.borderAll}
                        >
                          PENDING
                        </th>
                        <th
                          className="text-danger"
                          style={TABLE_STYLES.borderAll}
                        >
                          {feePending.reduce(
                            (total, item) =>
                              total + parseFloat(item.fee_amount || 0),
                            0,
                          )}
                        </th>
                      </tr>
                      <tr>
                        <th colSpan={2}>
                          <center>
                            <Link
                              className="text-center mt-1"
                              to="/stu/app/my-fees"
                            >
                              Click Here to pay now...
                            </Link>
                          </center>
                        </th>
                      </tr>
                    </table>
                  ) : (
                    <>
                      <center>NO PENDING</center>
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}

        {/* Apply Transfer */}
        {applyTransfer && feePending.length < 1 && !exists.student_uuid && (
          <Card className="mb-5">
            <Form noValidate validated={validated} onSubmit={handleFormSubmit}>
              <input type="hidden" name="sem_type" value={getSemType()} />

              {redoData && redoData.length > 0 && (
                <input
                  type="hidden"
                  name="redo_year"
                  value={momentDate(redoData[0]?.promotion_date, "YYYY-MM-DD")}
                />
              )}
              <input
                type="hidden"
                name="course_name"
                size="sm"
                value={context.user.course_name}
              />
              <input
                type="hidden"
                name="principal_sign"
                value={authoritySignFile}
              />

              <input type="hidden" name="ranklist_proof" value={ranklistFile} />

              <input
                type="hidden"
                name="student_sign"
                value={studentSignFile}
              />

              <Row>
                <Col md={12}>
                  <PsLabel text="விண்ணப்பதாரரின் பெயர்" required />
                  <Form.Control
                    type="text"
                    size="sm"
                    value={`${context.user.name} ${context.user.initial}`}
                    required
                  />
                </Col>
                <Col md={12} className="mt-2">
                  <input type="hidden" value={context.user.college_uuid} />
                  <PsLabel
                    text="விண்ணப்பதாரர் பயிலும் அரசு சட்டக் கல்லூரியின் பெயர்"
                    required
                  />
                  <Form.Control
                    type="text"
                    size="sm"
                    value={getCollegeFullName(context.user.college_uuid)}
                    required
                  />
                </Col>
                <Col md={12} className="mt-2">
                  <PsLabel
                    text="தற்பொழுது பயின்று வரும் வகுப்பு மற்றும் பயிற்று மொழி"
                    required
                  />
                  <Form.Control
                    type="text"
                    size="sm"
                    value={`${context.user.course_name} - ${upperCase(context.user.medium_of_instruction)}`}
                    className="input-field"
                    required
                  />
                </Col>
                <Col md={12} className="mt-2">
                  <PsLabel
                    text="ஏற்கனவே இடமாற்றம் பெற்றவரா? ஏற்கனவே இடமாற்றம் பெற்றவராயின், கண்டிப்பாக இவ்விண்ணப்பம் ஏற்றுக்கொள்ளப்படமாட்டாது."
                    required
                  />
                  <Form.Control
                    type="text"
                    size="sm"
                    value={
                      context.user.is_college_transfer == "1" ? "Yes" : "No"
                    }
                    className="input-field"
                    required
                  />
                </Col>
                <Col md={12} className="mt-2">
                  <PsLabel
                    text="விண்ணப்ப எண் (Application No.) (சட்டப்படிப்பு மாணவர் சேர்க்கைக்கு விண்ணப்பம் செய்தபோது வழங்கப்பட்ட எண்.)"
                    required
                  />
                  <Form.Control
                    type="text"
                    size="sm"
                    name="application_no"
                    placeholder="Enter Application No"
                    className="input-field"
                    required
                  />
                </Col>
                <Col md={12} className="mt-2">
                  <PsLabel
                    text="தர வரிசைப்பட்டியலில் (Rank List) மாணவர் பெற்ற மதிப்பெண். (நகல் இணைக்கப்பட வேண்டும்)"
                    required
                  />

                  <Row>
                    <Col xs={8}>
                      <ReactFileReader
                        base64={true}
                        handleFiles={fileReaderChange}
                        fileTypes={[
                          ".pdf",
                          ".doc",
                          ".docx",
                          ".jpg",
                          ".jpeg",
                          ".png",
                          ".JPG",
                          ".PNG",
                        ]}
                      >
                        <Button
                          size="sm"
                          type="button"
                          className="btn btn-info mt-2"
                        >
                          <i className="fa-solid fa-file me-2"></i>
                          {ranklistFile && ranklistFile.length > 0
                            ? "Change Document"
                            : "Select Document"}
                        </Button>
                      </ReactFileReader>
                    </Col>
                    <Col xs={4}>
                      {ranklistFile && ranklistFile.length > 0 && (
                        <>
                          {ranklistFileType == "image/jpg" ||
                          ranklistFileType == "image/png" ||
                          ranklistFileType == "image/jpeg" ||
                          ranklistFileType == "image/JPG" ||
                          ranklistFileType == "image/JPEG" ||
                          ranklistFileType == "image/PNG" ? (
                            <>
                              <a
                                className="img-close-btn"
                                onClick={(e) => setRanklistFile("")}
                              >
                                x
                              </a>
                              <Image
                                src={
                                  ranklistFile && ranklistFile.length > 0
                                    ? ranklistFile
                                    : ""
                                }
                                style={{
                                  width: "60px",
                                  cursor: "pointer",
                                  height: "60px",
                                }}
                              />
                            </>
                          ) : (
                            <>
                              <a
                                href={
                                  ranklistFile && ranklistFile.length > 0
                                    ? ranklistFile
                                    : ""
                                }
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: "#061277",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                View Document
                              </a>
                              <a
                                className="img-close-btn"
                                onClick={(e) => setRanklistFile("")}
                                style={{
                                  marginTop: "-7px",
                                  marginLeft: "4%",
                                }}
                              >
                                x
                              </a>
                            </>
                          )}
                        </>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col md={12} className="mt-2">
                  <PsLabel
                    text="தர வரிசைப்பட்டியலில் (Rank List) மாணவர் பெற்ற மதிப்பெண்."
                    required
                  />
                  <Form.Control
                    type="text"
                    size="sm"
                    name="student_percentage"
                    className="input-field"
                    required
                  />
                </Col>
                <Col md={12} className="mt-2">
                  <PsLabel text="இனம் (Community)" required />
                  <Form.Control
                    type="text"
                    size="sm"
                    name="community_name"
                    value={context.user.community_name}
                    className="input-field"
                    required
                  />
                </Col>
                <Col md={12} className="mt-2">
                  <PsLabel text="பிறந்த தேதி / மாதம்/ ஆண்டு" required />
                  <Form.Control
                    type="date"
                    size="sm"
                    value={context.user.dob}
                    className="input-field"
                    required
                  />
                </Col>
                <Col md={12} className="mt-2">
                  <input
                    type="hidden"
                    name="challan_date"
                    value={challanDate || "2026-01-01"}
                  />
                  <PsLabel
                    text="கல்விக்கட்டணம் செலுத்திய இரசீது எண் மற்றும் நாள்"
                    required
                  />
                  <Form.Control
                    type="text"
                    size="sm"
                    name="challan_no"
                    onChange={(e) => setChallanNo(e.target.value)}
                    value={challanNo}
                    className="input-field"
                    required
                  />
                </Col>
                <Col md={12} className="mt-2">
                  <PsLabel
                    text="மாணவர் ரீடு செய்யப்பட்டவராயின் எந்த ஆண்டு எனக் குறிப்பிடவும்."
                    required
                  />
                  <Form.Control
                    type="text"
                    size="sm"
                    value={
                      redoData && redoData.length > 0
                        ? momentDate(redoData[0]?.promotion_date, "DD-MM-YYYY")
                        : "No"
                    }
                    className="input-field"
                    required
                  />
                </Col>
                <Col md={12} className="mt-2">
                  <PsLabel
                    text="இடமாற்றம் கோரும் அரசு சட்டக் கல்லூரியின் பெயர்"
                    required
                  />
                  <PsSelect
                    dataSource={colleges}
                    placeholder="--Select College--"
                    className="fw-bold"
                    valueField="college_uuid"
                    lableField={(item) =>
                      `${item.college_code} - ${item.college_name}`
                    }
                    onChange={(d) => setSelectedCollege(d)}
                    value={selectedCollege}
                    inputName="to_college_uuid"
                  />
                </Col>
                <Col md={12} className="mt-2">
                  <PsLabel
                    text="இடமாற்றம் கோருவதற்கான காரணம். (சுருக்கமாக)"
                    required
                  />
                  <Form.Control
                    type="text"
                    size="sm"
                    name="transfer_reason"
                    className="input-field"
                    required
                  />
                </Col>
                <Col md={12} className="mt-2">
                  <PsLabel text="மாணவரின் / மாணவியின் கையொப்பம்" required />
                  <Row>
                    <Col xs={8}>
                      <ReactFileReader
                        base64={true}
                        handleFiles={fileReaderChangeSign}
                        fileTypes={[
                          ".pdf",
                          ".doc",
                          ".docx",
                          ".jpg",
                          ".jpeg",
                          ".png",
                          ".JPG",
                          ".PNG",
                        ]}
                      >
                        <Button
                          size="sm"
                          type="button"
                          className="btn btn-info mt-2"
                        >
                          <i className="fa-solid fa-file me-2"></i>
                          {studentSignFile && studentSignFile.length > 0
                            ? "Change Document"
                            : "Select Document"}
                        </Button>
                      </ReactFileReader>
                    </Col>
                    <Col xs={4}>
                      {studentSignFile && studentSignFile.length > 0 && (
                        <>
                          {studentSignFileType == "image/jpg" ||
                          studentSignFileType == "image/png" ||
                          studentSignFileType == "image/jpeg" ||
                          studentSignFileType == "image/JPG" ||
                          studentSignFileType == "image/JPEG" ||
                          studentSignFileType == "image/PNG" ? (
                            <>
                              <a
                                className="img-close-btn"
                                onClick={(e) => setStudentSignFile("")}
                              >
                                x
                              </a>
                              <img
                                src={
                                  studentSignFile && studentSignFile.length > 0
                                    ? studentSignFile
                                    : ""
                                }
                                style={{
                                  width: "60px",
                                  cursor: "pointer",
                                  height: "60px",
                                }}
                              />
                            </>
                          ) : (
                            <>
                              <a
                                href={
                                  studentSignFile && studentSignFile.length > 0
                                    ? studentSignFile
                                    : ""
                                }
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: "#061277",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                View Document
                              </a>
                              <a
                                className="img-close-btn"
                                onClick={(e) => setStudentSignFile("")}
                                style={{
                                  marginTop: "-7px",
                                  marginLeft: "4%",
                                }}
                              >
                                x
                              </a>
                            </>
                          )}
                        </>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col md={12} className="mt-2 text-center">
                  <Button type="submit" size="sm" className="">
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card>
        )}

        {/* Already Applied */}
        {exists.student_uuid && (
          <>
            <Card>
              <Card.Header className="card-header-bg text-uppercase fw-bold">
                <Row>
                  <Col xs={10}>Applied</Col>
                  <Col xs={2} className="text-end">
                    <Button
                      size="sm"
                      variant="light"
                      onClick={() => loadData()}
                    >
                      <i class="fa-solid fa-rotate"></i>
                    </Button>
                  </Col>
                </Row>
              </Card.Header>

              <Card.Body className="p-1">
                <PsLabel text="College From" />
                <Form.Control
                  type="text"
                  size="sm"
                  value={getCollegeFullName(exists?.from_college_uuid)}
                  required
                />
                <span className="my-1"></span>
                <PsLabel text="College To" />
                <Form.Control
                  type="text"
                  size="sm"
                  value={getCollegeFullName(exists?.to_college_uuid)}
                  required
                />
              </Card.Body>
            </Card>

            {/* Officer Approval */}
            <Card className="mt-2">
              <Card.Header className="card-header-bg text-uppercase fw-bold">
                Office Approval
              </Card.Header>

              <Card.Body>
                <Row>
                  <Col md={9} sm={9} xs={9}>
                    <table width="100%">
                      <tr>
                        <th>Status</th>
                        <td>:</td>
                        <td>{upperCase(exists.office_approval)}</td>
                      </tr>
                      <tr>
                        <th>Reason</th>
                        <td>:</td>
                        <td>{exists.office_approval_reason}</td>
                      </tr>
                      <tr>
                        <th width="40%">Approved On</th>
                        <td width="2%">:</td>
                        <td width="58%">
                          {momentDate(exists.office_approved_on, "DD-MM-YYYY")}{" "}
                          {momentDate(exists.office_approved_on, "hh:mm A")}
                        </td>
                      </tr>
                    </table>
                  </Col>
                  <Col md={3} sm={3} xs={3}>
                    {exists.office_approval != "approved" ? (
                      <img src={MOB_ICONS.PENDING} style={{ width: "60px" }} />
                    ) : (
                      <img
                        src={MOB_ICONS.APPROVED}
                        style={{ width: "100px" }}
                      />
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Principal Approval */}
            <Card className="mt-2">
              <Card.Header className="card-header-bg text-uppercase fw-bold">
                Principal Approval
              </Card.Header>

              <Card.Body>
                <Row>
                  <Col md={9} sm={9} xs={9}>
                    <table width="100%">
                      <tr>
                        <th>Status</th>
                        <td>:</td>
                        <td>{upperCase(exists.principal_approval)}</td>
                      </tr>
                      <tr>
                        <th>Reason</th>
                        <td>:</td>
                        <td>{exists.principal_approval_reason}</td>
                      </tr>
                      <tr>
                        <th width="40%">Approved On</th>
                        <td width="2%">:</td>
                        <td width="58%">
                          {momentDate(
                            exists.principal_approved_on,
                            "DD-MM-YYYY",
                          )}{" "}
                          {momentDate(exists.principal_approved_on, "hh:mm A")}
                        </td>
                      </tr>
                    </table>
                  </Col>
                  <Col md={3} sm={3} xs={3}>
                    {exists.principal_approval != "approved" ? (
                      <img src={MOB_ICONS.PENDING} style={{ width: "60px" }} />
                    ) : (
                      <img
                        src={MOB_ICONS.APPROVED}
                        style={{ width: "100px" }}
                      />
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* DLS Approval */}
            <Card className="mt-2 mb-5">
              <Card.Header className="card-header-bg text-uppercase fw-bold">
                DLS Approval
              </Card.Header>

              <Card.Body>
                <Row>
                  <Col md={9} sm={9} xs={9}>
                    <h6 className="mt-4">
                      {upperCase(exists?.applied_status)}
                    </h6>
                  </Col>
                  <Col md={3} sm={3} xs={3}>
                    {exists.applied_status != "approved" ? (
                      <img src={MOB_ICONS.PENDING} style={{ width: "60px" }} />
                    ) : (
                      <img
                        src={MOB_ICONS.APPROVED}
                        style={{ width: "100px" }}
                      />
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </>
        )}
      </div>
    </div>
  );
};

export default StudentTransfer;
